// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1ZIXT","col":"Table_col__2WLpc","fulfillmentStatus":"Table_fulfillmentStatus__3S-kO","emailCol":"Table_emailCol__3AsZ6"};